import { render } from "./CallbackRequestCard.vue?vue&type=template&id=59854d04&scoped=true"
import script from "./CallbackRequestCard.vue?vue&type=script&lang=js"
export * from "./CallbackRequestCard.vue?vue&type=script&lang=js"

import "./CallbackRequestCard.vue?vue&type=style&index=0&id=59854d04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59854d04"]])

export default __exports__